var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "widthFull container-fluid mainBackVaillant pt-5 mt-5" },
    [
      _c("div", { staticClass: "row justify-content-center " }, [
        _c(
          "div",
          { staticClass: "widthFull container vaillantCont pt-5 mt-5" },
          [
            _c("div", { staticClass: "row justify-content-center pb-5 mb-5" }, [
              _vm._m(0),
              _vm._v(" "),
              _c("div", { staticClass: "col-md-6  center" }, [
                _c("h1", { staticClass: "h2 center Regular Bold  " }, [
                  _c("b", [_vm._v("Pratica " + _vm._s(_vm.practice))])
                ]),
                _vm._v(" "),
                _vm._m(1),
                _vm._v(" "),
                _vm._m(2)
              ]),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "col-md-12 mt-5 center" },
                [
                  _c(
                    "router-link",
                    {
                      staticClass: "btn btn-secondary btn-lg",
                      attrs: { to: "/pratiche" }
                    },
                    [_vm._v(" Gestione Pratiche ")]
                  )
                ],
                1
              )
            ])
          ]
        )
      ])
    ]
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "col-md-12  center" }, [
      _c("img", {
        staticClass: "img-fluid payImage",
        attrs: { src: require("../../assets/images/success.png") }
      })
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("h4", { staticClass: "center" }, [
      _c("b", [_vm._v("Grazie per averci scelto, ")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("h3", { staticClass: "center " }, [
      _c("b", [_vm._v("il tuo pagamento è avvenuto con successo")])
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-48050120", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-48050120","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/paymentSuccess/index.vue
// module id = null
// module chunks = 